import React from 'react';
import PropTypes from 'prop-types';

// Small inline SVG icons for the senior gallery. Inline (not image assets) so they
// inherit currentColor and scale with Tailwind h-*/w-* utilities.

export const CapIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 3 1 8l11 5 9-4.09V15h2V8L12 3z" />
    <path d="M5 11.18V15c0 1.66 3.13 3 7 3s7-1.34 7-3v-3.82l-7 3.18-7-3.18z" />
  </svg>
);

export const HeartIcon = ({ className, filled }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth={filled ? 0 : 2}
    aria-hidden="true"
  >
    <path d="M12 21s-7.5-4.9-10-8.5C.5 9.5 2 5.5 6 5.5c2 0 3.2 1.1 4 2 .8-.9 2-2 4-2 4 0 5.5 4 4 7-2.5 3.6-10 8.5-10 8.5z" />
  </svg>
);

export const CheckCircleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.2 14.2-4-4L8.2 10.8l2.6 2.6 5-5L17.2 9.8l-6.4 6.4z" />
  </svg>
);

CapIcon.defaultProps = { className: '' };
CapIcon.propTypes = { className: PropTypes.string };

HeartIcon.defaultProps = { className: '', filled: false };
HeartIcon.propTypes = { className: PropTypes.string, filled: PropTypes.bool };

CheckCircleIcon.defaultProps = { className: '' };
CheckCircleIcon.propTypes = { className: PropTypes.string };
